import { API } from 'aws-amplify';
import APIRoutes from '../../api/routes';

export const FETCHSTATES = 'FETCHSTATES';
export const FETCHCOUNTRY = 'FETCHCOUNTRY';


export const fetchStateCodes = (dispatch, formData) => {
    API.post('DEFAULT_ENDPOINT', APIRoutes.stateCodes, {
        body: formData
    })
        .then(res => {
            dispatch({
                type: FETCHSTATES,
                payload: res
            })
        })
}

export const fetchCountryCodes = (dispatch, formData) => {
    API.post('DEFAULT_ENDPOINT', APIRoutes.countriesCodes, {
        body: formData
    })
        .then(res => {
            dispatch({
                type: FETCHCOUNTRY,
                payload: res
            })
        })
}

export const searchCountryCodes = (formData,callback) => {
    API.post('DEFAULT_ENDPOINT', APIRoutes.countriesCodes, {
        body: formData
    })
        .then(res => {
            callback(res)
        })
}
